import {
  EXIT_DURATION
} from "./chunk-2BQQXROV.mjs";
import {
  __spreadProps,
  __spreadValues
} from "./chunk-3IID4MV4.mjs";

// src/core.ts
var toastCounter = 0;
var Observer = class {
  constructor() {
    this.subscribe = (subscriber) => {
      this.subscribers.push(subscriber);
    };
    this.unsubscribe = (subscriber) => {
      this.subscribers = this.subscribers.filter(
        (_subscriber) => _subscriber !== subscriber
      );
    };
    this.publish = (toast2) => {
      this.subscribers.forEach((subscriber) => {
        subscriber(toast2);
      });
    };
    this.addToast = (toast2) => {
      let alreadyExists = false;
      this.toasts.forEach((t) => {
        if (!t.delete) {
          alreadyExists = true;
          this.dismiss(t.id, true);
          setTimeout(() => {
            this.delete(t.id);
          }, EXIT_DURATION);
        }
      });
      this.toasts.push(toast2);
      this.publish(__spreadProps(__spreadValues({}, toast2), { immediateEnter: alreadyExists }));
    };
    this.create = (data) => {
      var _a;
      const id = (_a = data.id) != null ? _a : ++toastCounter;
      const alreadyExists = this.toasts.some((toast2) => toast2.id === id);
      if (alreadyExists) {
        this.toasts = this.toasts.map((toast2) => {
          if (toast2.id === id) {
            this.publish(__spreadValues(__spreadValues({}, toast2), data));
            return __spreadValues(__spreadValues({}, toast2), data);
          }
          return toast2;
        });
      } else {
        this.addToast(__spreadValues({
          id,
          delete: false,
          dismiss: false
        }, data));
      }
      return id;
    };
    this.dismiss = (id, immediateDismiss = false) => {
      const toast2 = this.toasts.find((t) => t.id === id);
      if (!toast2)
        return;
      this.toasts = this.toasts.map((t) => {
        if (t.id !== toast2.id)
          return t;
        return __spreadProps(__spreadValues({}, t), { dismiss: true });
      });
      this.publish(__spreadProps(__spreadValues({}, toast2), { immediateDismiss, dismiss: true }));
    };
    this.delete = (id) => {
      const toast2 = this.toasts.find((t) => t.id === id);
      if (!toast2)
        return;
      this.toasts = this.toasts.map((t) => {
        if (t.id !== toast2.id)
          return t;
        return __spreadProps(__spreadValues({}, t), { immediateDismiss: false, delete: true });
      });
      this.publish(__spreadProps(__spreadValues({}, toast2), { immediateDismiss: false, delete: true }));
    };
    this.unmount = (id) => {
      const toast2 = this.toasts.find((t) => t.id === id);
      if (!id || !toast2) {
        this.toasts.forEach((t) => {
          this.dismiss(t.id);
          setTimeout(() => {
            this.delete(t.id);
          }, EXIT_DURATION);
        });
        return;
      }
      this.dismiss(id);
      setTimeout(() => {
        this.delete(id);
      }, EXIT_DURATION);
    };
    this.info = (message, options) => {
      return this.create(__spreadValues({
        message,
        type: "info"
      }, options));
    };
    this.warning = (message, options) => {
      return this.create(__spreadValues({
        message,
        type: "warning"
      }, options));
    };
    this.error = (message, options) => {
      return this.create(__spreadValues({
        message,
        type: "error"
      }, options));
    };
    this.success = (message, options) => {
      return this.create(__spreadValues({
        message,
        type: "success"
      }, options));
    };
    this.custom = (jsx, options) => {
      const id = ++toastCounter;
      return this.create(__spreadValues({
        message: jsx(id),
        type: "custom"
      }, options));
    };
    this.subscribers = [];
    this.toasts = [];
  }
};
var observer = new Observer();
function basicToast(message, options) {
  var _a;
  const id = (_a = options == null ? void 0 : options.id) != null ? _a : ++toastCounter;
  observer.addToast(__spreadValues({
    id,
    message,
    type: "basic",
    delete: false,
    dismiss: false
  }, options));
  return id;
}
var toast = Object.assign(basicToast, {
  info: observer.info,
  warning: observer.warning,
  error: observer.error,
  success: observer.success,
  custom: observer.custom,
  dismiss: observer.unmount
});
function basicSnackBar(message, options) {
  var _a;
  const id = (_a = options == null ? void 0 : options.id) != null ? _a : ++toastCounter;
  observer.addToast(__spreadValues({
    id,
    message,
    type: "basic",
    delete: false,
    dismiss: false,
    duration: 3500,
    stretch: {
      mobile: true,
      desktop: false
    }
  }, options));
}
var snackBar = Object.assign(basicSnackBar, {
  info: (message, options) => {
    observer.info(message, __spreadValues({
      duration: 3500,
      stretch: { mobile: true, desktop: false }
    }, options));
  },
  warning: (message, options) => {
    observer.warning(message, __spreadValues({
      duration: 3500,
      stretch: { mobile: true, desktop: false }
    }, options));
  },
  error: (message, options) => {
    observer.error(message, __spreadValues({
      duration: 3500,
      stretch: { mobile: true, desktop: false }
    }, options));
  },
  success: (message, options) => {
    observer.success(message, __spreadValues({
      duration: 3500,
      stretch: { mobile: true, desktop: false }
    }, options));
  },
  custom: observer.custom,
  dismiss: observer.unmount
});

export {
  observer,
  toast,
  snackBar
};
